import styled from 'styled-components'

export const InputSubmitWrapper = styled.div`
  max-width: max-content;
  display: grid;
  gap: 8px;
  grid-template-columns: auto auto;
`
